import http from './api'

const logger = {
  log(message, level = 'INFO') {
    const timestamp = new Date().toISOString()
    const logEntry = { timestamp, level, message }

    console.log(`[${timestamp}] [${level}] ${message}`)

    // Envoyer le log au backend NestJS
    http.post('/logs', logEntry).catch((err) => console.error("Erreur d'envoi du log :", err))
  },

  error(message) {
    this.log(message, 'ERROR')
  },
}

export default logger
